import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

const DAYS = ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"];

export default function AdminDailyMenu() {
  const [menus, setMenus] = useState([]);
  const [items, setItems] = useState([]);
  const [day, setDay] = useState("Monday");
  const [form, setForm] = useState({ day_of_week: "Monday", title: "Monday Royal Menu", item_ids: [], promo_banner: "", published: true });

  useEffect(() => {
    api.get("/menu").then(({data}) => setItems(data));
    api.get("/daily-menus").then(({data}) => setMenus(data));
  }, []);

  useEffect(() => {
    const m = menus.find(x => x.day_of_week === day);
    if (m) setForm({ ...m });
    else setForm({ day_of_week: day, title: `${day} Royal Menu`, item_ids: [], promo_banner: "", published: true });
  }, [day, menus]);

  const toggle = (id) => {
    setForm(f => ({ ...f, item_ids: f.item_ids.includes(id) ? f.item_ids.filter(x => x !== id) : [...f.item_ids, id] }));
  };

  const save = async () => {
    try {
      await api.post("/daily-menus", form);
      toast.success(`${day} menu saved`);
      const { data } = await api.get("/daily-menus"); setMenus(data);
    } catch { toast.error("Save failed"); }
  };

  return (
    <div data-testid="admin-daily-menu">
      <h1 className="font-heading text-3xl text-[#FAF9F6] mb-4">Daily Menu Builder</h1>
      <div className="flex gap-2 mb-5 overflow-x-auto no-scrollbar">
        {DAYS.map(d => (
          <button key={d} onClick={() => setDay(d)} data-testid={`day-tab-${d}`} className={`px-4 py-2 text-xs font-accent uppercase whitespace-nowrap ${day === d ? "bg-[#D4AF37] text-[#050505]" : "border border-[#D4AF37]/40 text-[#D4AF37]"}`}>{d}</button>
        ))}
      </div>

      <div className="grid lg:grid-cols-[2fr_1fr] gap-5">
        <div className="admin-card p-5">
          <h3 className="font-heading text-xl text-[#D4AF37] mb-3">Select items for {day}</h3>
          <div className="grid sm:grid-cols-2 gap-2 max-h-[60vh] overflow-y-auto">
            {items.map(it => (
              <label key={it.id} className={`p-3 rounded border cursor-pointer text-sm flex items-center gap-3 ${form.item_ids.includes(it.id) ? "bg-[#D4AF37]/10 border-[#D4AF37]" : "border-white/10 bg-[#0B0E14]"}`} data-testid={`dm-item-${it.id}`}>
                <input type="checkbox" checked={form.item_ids.includes(it.id)} onChange={() => toggle(it.id)} className="accent-[#D4AF37]"/>
                <div className="flex-1">
                  <div className="font-heading text-[#FAF9F6]">{it.name}</div>
                  <div className="text-xs text-[#FAF9F6]/50">{it.category} · ${it.price.toFixed(2)}</div>
                </div>
              </label>
            ))}
          </div>
        </div>
        <div className="admin-card p-5 h-fit">
          <h3 className="font-heading text-xl text-[#D4AF37] mb-3">Menu details</h3>
          <input value={form.title} onChange={(e) => setForm({...form, title: e.target.value})} placeholder="Menu title" className="w-full bg-[#0B0E14] border border-[#D4AF37]/30 px-3 py-2 text-[#FAF9F6] rounded mb-2"/>
          <input value={form.promo_banner || ""} onChange={(e) => setForm({...form, promo_banner: e.target.value})} placeholder="Promo banner text" className="w-full bg-[#0B0E14] border border-[#D4AF37]/30 px-3 py-2 text-[#FAF9F6] rounded mb-2"/>
          <label className="flex gap-2 text-sm text-[#FAF9F6] mb-3"><input type="checkbox" checked={form.published} onChange={(e) => setForm({...form, published: e.target.checked})}/> Published</label>
          <div className="text-xs text-[#FAF9F6]/50 mb-3">{form.item_ids.length} items selected</div>
          <button onClick={save} data-testid="daily-save" className="btn-chow w-full">Save {day} menu</button>
        </div>
      </div>
    </div>
  );
}
